module.exports = __webpack_public_path__ + "img/symbol_7.18fcee23.png";